<template>
  <div class="page-404">
     <v-row>
      <v-spacer></v-spacer>
      <v-col :md="2">
        <v-btn class="ma-2" tile text outlined color="#4caf50" @click="toPage('/')">回 到 首 页</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  methods:{
    toPage(url){
      this.$router.push({path:url})
    },
  }
}
</script>

<style lang="stylus" scoped>
.page-404
  width 100%
  height:100%
  position absolute
  background-repeat no-repeat
  background-size  100% 100%
  background-image url('../assets/imgs/bg/404.jpg')

</style>